const isNumeric = (str) => {
  if (typeof str === "number") return true;
  if (typeof str !== "string") return false;
  if (str.trim() === "") return false;
  return !Number.isNaN(Number(str));
};
const checkNumeric = (a, b, callback) => {
  if (isNumeric(a) && isNumeric(b)) {
    return callback(parseFloat(a), parseFloat(b));
  }
  return false;
};
const highlightConditionFunctions = {
  equal: (a, b) => String(a) === String(b),
  not_equal: (a, b) => String(a) !== String(b),
  less_equal: (a, b) => checkNumeric(a, b, (aFloat, bFloat) => aFloat <= bFloat),
  greater_equal: (a, b) => checkNumeric(a, b, (aFloat, bFloat) => aFloat >= bFloat),
  greater: (a, b) => checkNumeric(a, b, (aFloat, bFloat) => aFloat > bFloat),
  less: (a, b) => checkNumeric(a, b, (aFloat, bFloat) => aFloat < bFloat)
};
export default highlightConditionFunctions;
